// Copyright (c) 2024. UpCircle Technology AG.
// All rights reserved. Redistribution in source and/or binary forms,
// with or without modification, is not permitted.

import React from 'react'
import "./ImageSquare.scss"
import { fetchImageThumbnailUrl } from '../../shared_components/utils/ImgUtils';

export default function ImageSquare({ storage, imageUrl, setGreyedOut=false, icons=[] }) {
    const [imageUrlAuth, setImageUrlAuth] = React.useState("");
    const [isLoaded, setIsLoaded] = React.useState(false);

    React.useEffect(() => {
        if (!imageUrl) return;
        if (imageUrl.startsWith("data:image")) {
            // This means it is not actually an URL but the image data itself
            setImageUrlAuth(imageUrl);
        } else {
            fetchImageThumbnailUrl(storage, imageUrl).then((url) => {
                setImageUrlAuth(url);
            })
        }
    }, [imageUrl]);

    return (
        <div className={"image_square"}>
            { imageUrlAuth && <img className={`image_square--img ${setGreyedOut && "greyed-out"}`}
                src={imageUrlAuth}
                onLoad={() => setIsLoaded(true)}
                style={{ display: isLoaded ? 'block' : 'none' }}
            /> }
            { icons && 
            <div className="image_square--icons-container">
                { icons.map((icon, index) => {
                    return <img key={index} className="image_square--icon" src={icon} />
                }) }
            </div> }
        </div>
    )
}